import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormHexagon"><Path d="M12 2L20.6603 7V17L12 22L3.33975 17V7L12 2Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconFormHexagon;
